import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF, Stage, Grid } from '@react-three/drei';

interface ModelViewerProps {
  url: string;
  showGrid?: boolean;
}

function Model({ url }: { url: string }) {
  const { scene } = useGLTF(url);
  return <primitive object={scene} />;
}

export default function ModelViewer({ url, showGrid = true }: ModelViewerProps) {
  return (
    <div style={{ width: '100%', height: '100%', minHeight: '400px', borderRadius: '0.75rem', overflow: 'hidden' }}>
      <Canvas shadows camera={{ position: [0, 1.5, 4], fov: 45 }}>
        <Suspense fallback={null}>
          <Stage environment="city" intensity={0.6}>
            <Model url={url} />
          </Stage>
        </Suspense>
        {showGrid && <Grid cellSize={0.5} cellThickness={1} sectionSize={2} fadeDistance={20} infiniteGrid />}
        <OrbitControls makeDefault autoRotate autoRotateSpeed={1} />
      </Canvas>
    </div>
  );
}
